import { render, staticRenderFns } from "./Newspaper.vue?vue&type=template&id=0c5f172e&scoped=true"
var script = {}
import style0 from "./Newspaper.vue?vue&type=style&index=0&id=0c5f172e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5f172e",
  null
  
)

export default component.exports